/* Cyber 2026: comportamiento de las secciones syvcy-* (video de portada, escalones, aparición, contador, tabla). */
(function () {
  if (window.__syvcy) return; window.__syvcy = true;
  var reducido = matchMedia('(prefers-reduced-motion:reduce)').matches;
  var editor = window.Shopify && Shopify.designMode;
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('cy-ya'); io.unobserve(e.target); } });
  }, { threshold: 0.12 }) : null;

  function video(v) {
    var movil = matchMedia('(max-width:760px)').matches;
    var poster = movil ? v.dataset.cyPosterMovil : v.dataset.cyPosterPc;
    if (poster) v.poster = poster;
    var src = movil ? (v.dataset.cyMovil || v.dataset.cyPc) : v.dataset.cyPc;
    if (!reducido && src) { v.src = src; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }
  function escalones(raiz) {
    var esc = raiz.querySelector('[data-cy-escena]'); if (!esc) return;
    var rot = esc.querySelector('[data-cy-rotulo]');
    var bts = [].slice.call(raiz.querySelectorAll('.cy-escalones button'));
    function ver(b, fijar) {
      esc.dataset.ver = b.dataset.ver;
      [].forEach.call(esc.querySelectorAll('.cy-pack'), function (i) { i.classList.toggle('cy-ve', i.dataset.ver === b.dataset.ver); });
      if (rot) rot.innerHTML = b.dataset.rot || '';
      if (fijar) bts.forEach(function (x) { x.classList.toggle('cy-on', x === b); });
    }
    function foto() { esc.dataset.ver = 'foto'; [].forEach.call(esc.querySelectorAll('.cy-pack'), function (i) { i.classList.remove('cy-ve'); }); }
    bts.forEach(function (b) {
      b.addEventListener('mouseenter', function () { ver(b); });
      b.addEventListener('focus', function () { ver(b); });
      b.addEventListener('click', function () { ver(b, true); });
    });
    var g = raiz.querySelector('.cy-escalones');
    // Los productos rotan solos (foto, pack 1, pack 2...) hasta que alguien los toca; al soltar vuelven a rotar.
    var items = [null].concat(bts), turno = 0, reloj = null, fijo = false;
    function sig() { if (document.hidden || raiz.classList.contains('cy-fuera')) return; turno = (turno + 1) % items.length; if (items[turno]) ver(items[turno], true); else { foto(); bts.forEach(function (x) { x.classList.remove('cy-on'); }); } }
    function seguir() { if (reducido || editor || fijo || reloj || items.length < 2) return; reloj = setInterval(sig, 3600); }
    function parar() { clearInterval(reloj); reloj = null; }
    bts.forEach(function (b) { b.addEventListener('click', function (e) { if (e.isTrusted) { fijo = true; parar(); } }); });
    if (g) { g.addEventListener('mouseenter', parar); g.addEventListener('mouseleave', function () { if (!fijo) { turno = 0; foto(); seguir(); } else { /* queda el pack elegido */ } }); }
    setTimeout(seguir, 1500);
  }
  // Planes del Club: se puede elegir uno y el botón se anima para invitar a entrar.
  function planes(raiz) {
    var ps = [].slice.call(raiz.querySelectorAll('.cy-planes .cy-plan')); if (!ps.length) return;
    var cta = raiz.querySelector('.cy-club-cab .cy-boton');
    ps.forEach(function (p) {
      p.tabIndex = 0; p.setAttribute('role', 'button'); p.setAttribute('aria-pressed', 'false');
      function elegir() {
        ps.forEach(function (x) { x.classList.toggle('cy-sel', x === p); x.setAttribute('aria-pressed', x === p ? 'true' : 'false'); });
        if (cta) { cta.classList.remove('cy-llama'); void cta.offsetWidth; cta.classList.add('cy-llama'); }
      }
      p.addEventListener('click', elegir);
      p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); elegir(); } });
    });
  }
  function contador(c) {
    var fin = new Date(c.dataset.cyFin).getTime(); if (isNaN(fin)) return;
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var q = function (k) { return c.querySelector('[data-cy-' + k + ']'); };
    function tic() {
      var r = Math.max(0, fin - Date.now()) / 1000;
      if (r <= 0 && c.dataset.cyOcultar === 'true' && !editor) { var s = c.closest('.shopify-section'); if (s) s.style.display = 'none'; }
      q('d').textContent = pad(Math.floor(r / 86400)); q('h').textContent = pad(Math.floor(r % 86400 / 3600));
      q('m').textContent = pad(Math.floor(r % 3600 / 60)); q('s').textContent = pad(Math.floor(r % 60));
    }
    tic(); clearInterval(c.__cyT); c.__cyT = setInterval(tic, 1000);
  }
  // Tira de recetas: gira sola y se puede arrastrar con el mouse, el dedo o el trackpad.
  function tira(t) {
    if (t.dataset.cyTira) return; t.dataset.cyTira = '1';
    var x = 0, v = 0, mitad = 0, arr = false, hov = false, sx = 0, x0 = 0, ult = 0, vel = reducido ? 0 : 0.45;
    t.style.animation = 'none'; t.classList.add('cy-arrastra');
    function medir() { mitad = t.scrollWidth / 2; }
    medir(); window.addEventListener('resize', medir); window.addEventListener('load', medir);
    var vista = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vista = es[0].isIntersecting; }, { rootMargin: '120px' }).observe(t);
    function paso() {
      if (!vista) { requestAnimationFrame(paso); return; }
      if (!arr) { x += v; v *= 0.94; if (Math.abs(v) < 0.05) v = 0; if (!hov && !v) x -= vel; }
      if (mitad) { if (x <= -mitad) x += mitad; if (x > 0) x -= mitad; }
      t.style.transform = 'translate3d(' + x + 'px,0,0)'; requestAnimationFrame(paso);
    }
    t.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' && e.button) return; arr = true; sx = e.clientX; x0 = x; ult = e.clientX; v = 0; t.classList.add('cy-agarra'); try { t.setPointerCapture(e.pointerId); } catch (_) {} });
    t.addEventListener('pointermove', function (e) { if (!arr) return; x = x0 + (e.clientX - sx); v = (e.clientX - ult) * 0.9; ult = e.clientX; });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (n) { t.addEventListener(n, function () { arr = false; t.classList.remove('cy-agarra'); }); });
    t.addEventListener('mouseenter', function () { hov = true; }); t.addEventListener('mouseleave', function () { hov = false; });
    t.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { e.preventDefault(); x -= e.deltaX; v = 0; } }, { passive: false });
    t.addEventListener('dragstart', function (e) { e.preventDefault(); });
    paso();
  }
  // Fuera de pantalla se pausan las animaciones CSS de cada sección y los videos (decodificar a escondidas gasta GPU y batería).
  var vigila = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var s = e.target; s.classList.toggle('cy-fuera', !e.isIntersecting);
      [].forEach.call(s.querySelectorAll('video[data-cy-vista],video[data-cy-pc]'), function (v) {
        if (e.isIntersecting && !reducido) { if (v.getBoundingClientRect().width > 8) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } } else v.pause();
      });
    });
  }, { rootMargin: '80px' }) : null;
  function iniciar(raiz) {
    [].forEach.call(raiz.querySelectorAll('.syvcy'), function (s) {
      if (s.dataset.cyOk) return; s.dataset.cyOk = '1';
      if (vigila && !editor) vigila.observe(s);
      [].forEach.call(s.querySelectorAll('video[data-cy-pc]'), video);
      escalones(s);
      planes(s);
      [].forEach.call(s.querySelectorAll('.cy-tira'), tira);
      [].forEach.call(s.querySelectorAll('[data-cy-fin]'), contador);
      var on = s.querySelector('.cy-escalones button.cy-on'); if (on) on.click();
      var esc = s.querySelector('[data-cy-escena]'); if (esc) { esc.dataset.ver = 'foto'; [].forEach.call(esc.querySelectorAll('.cy-pack'), function (i) { i.classList.remove('cy-ve'); }); }
      [].forEach.call(s.querySelectorAll('.cy-sube'), function (el) { if (io && !editor) io.observe(el); else el.classList.add('cy-ya'); });
    });
  }
  // La cabecera de la tienda es pegajosa: la tabla del Club fija su encabezado justo debajo.
  var cab = null, pend = false;
  function topCabecera() {
    pend = false;
    cab = cab || document.querySelector('.shopify-section-header-sticky, sticky-header, .section-header');
    var b = 0; if (cab) { var r = cab.getBoundingClientRect(); b = Math.max(0, r.bottom); }
    document.documentElement.style.setProperty('--cy-top', Math.round(b) + 'px');
  }
  window.addEventListener('scroll', function () { if (!pend) { pend = true; requestAnimationFrame(topCabecera); } }, { passive: true });
  window.addEventListener('resize', topCabecera);
  function todo() { iniciar(document); topCabecera(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo();
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
